module.exports = __webpack_public_path__ + "img/sr.d23d819.svg";